<template>
  <c-base-dialog
      v-model="/* eslint-disable-next-line vue/no-mutating-props */
                value"
      :option="showChangeBindPhoneOption"
      @close="closeDetailModal()"
      v-transfer-dom
  >
    <template slot="body">
      <slot name="c-base-bind-game"></slot>
    </template>
  </c-base-dialog>
</template>

<script>
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'c-base-repeatedly-dialog',
  components: {
    [CDialog.name]: CDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dialogOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    showChangeBindPhoneOption() {
      return {
        height: 'auto',
        width: '6rem',
        footer: false,
        header: false,
        confirm: false,
        dialogStyle: {
          color: '#444241',
          padding: '0 0',
        },
        closeLocation: 'bottom-center',
        closeStyle: {
          backgroundImage:
              'url(https://game.gtimg.cn/images/js/img/supercode/contract/closeicon.png)',
          width: '0.5rem',
          height: '0.5rem',
          bottom: '-0.5rem',
        },
        close: false,
      };
    },
  },
  methods: {
    closeDetailModal() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">

</style>
